import permissions from '../../permissions'

const MONITORING_MANAGEMENT_NC_LIST = [
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.LIST,
    tag: permissions.MONITORING_MANAGEMENT_NC.LIST,
  },
  {
    name: permissions.PERMISSIONS_DEFAULT_LABEL.MANAGE,
    tag: permissions.MONITORING_MANAGEMENT_NC.MANAGE,
  },
]

export default MONITORING_MANAGEMENT_NC_LIST
